export interface ObligationExtractionAccessState {
    hasAiFeaturesAddOn: boolean;
    hasObligationsAddOn: boolean;
    isAiSpendingExhausted: boolean;
}

/**
 * Why the action cannot be used, as a translation key, or undefined when it can.
 *
 * Both add-ons are required and for different halves of the work: the scan needs AI Features and the
 * obligation it creates needs Contract Obligations. A customer missing both is told about both, rather
 * than buying one and finding the action still dead.
 *
 * The add-ons come before the spending limit because owning them is what makes spending matter at all,
 * and every reason has to name itself: the action is disabled either way, and a disabled control that
 * keeps its ordinary label leaves the reader with nothing to act on.
 */
export function getObligationExtractionBlockedTranslationKey(state: ObligationExtractionAccessState): string | undefined {
    if (!state.hasAiFeaturesAddOn && !state.hasObligationsAddOn) {
        return "aiAndObligationsAddOnsPurchaseTooltip";
    }

    if (!state.hasObligationsAddOn) {
        return "upgradeToObligationsAddOn";
    }

    if (!state.hasAiFeaturesAddOn) {
        return "aiAddOnPurchaseTooltip";
    }

    if (state.isAiSpendingExhausted) {
        return "aiSpendingLimitReached";
    }

    return undefined;
}
